<div [class]="'kt-portlet--height-fluid container'" *ngIf="data">
  <h2 class="page-titel">Merchant Business Profile for : {{ data.name }}</h2>
    <div class="row">
      <div class="form-group col-lg-4">
        <p class="merchant-keys" (click)="copyToClipboard(data.clientId)">
          <mat-icon style="margin-left: .75rem" class="text-dark">content_copy</mat-icon>clientid: &nbsp;
          <span
              class="text-dark">{{ data.clientId }}
          </span>
        </p>
      </div>
      <div class="form-group col-lg-4">
        <p class="merchant-keys" (click)="copyToClipboard(data.secretId)">
          <mat-icon style="margin-left: .75rem" class="text-dark">content_copy</mat-icon>secretid: &nbsp;
          <span
              class="text-dark">{{ data.secretId }}
          </span>
        </p>
      </div>
  </div>
  <button class="btn btn-primary" (click)="regenerateKeys()">Regenerate Keys</button>
</div>

